<template>
  <CDialog v-model="isOpen">
    <header class="dialog-header align-items-start">
      <div class="flex-fill pdgr">
        <h1 class="h4 mrgv0">
          {{ $t(`contacts.${contact.id ? 'edit' : 'add'}.title`) }}
        </h1>
      </div>

      <Btn variant="icon" @click="isOpen = !isOpen">
        <Icon id="close" :scale="0.75" />
      </Btn>
    </header>

    <main class="dialog-body">
      <div v-if="!contact.id" class="toast toast--no-shadow warn mrgb">
        {{ $t('contacts.add.warning') }}
      </div>

      <ValidationObserver>
        <Form @passed="submit">
          <Grid multiline>
            <GridItem :widths="{ default: '1/1' }">
              <FormGroup
                id="firstname"
                name="firstname"
                :label="$t('contacts.fields.firstname')"
                rules="required"
                required
                row
              >
                <Input
                  id="firstname"
                  v-model="contact.first_name"
                  name="firstname"
                  required
                />
              </FormGroup>
            </GridItem>

            <GridItem :widths="{ default: '1/1' }">
              <FormGroup
                id="lastname"
                name="lastname"
                :label="$t('contacts.fields.lastname')"
                rules="required"
                required
                row
              >
                <Input
                  id="lastname"
                  v-model="contact.last_name"
                  name="lastname"
                  required
                />
              </FormGroup>
            </GridItem>

            <GridItem :widths="{ default: '1/1' }">
              <FormGroup
                id="company"
                name="company"
                :label="$t('contacts.fields.company')"
                row
              >
                <Input id="company" v-model="contact.company" name="company" />
              </FormGroup>
            </GridItem>

            <GridItem :widths="{ default: '1/1' }">
              <FormGroup
                id="phone"
                name="phone"
                :label="$t('contacts.fields.phone')"
                rules="required|phone"
                required
                row
              >
                <Input
                  id="phone"
                  v-model="contact.username"
                  name="phone"
                  required
                />
              </FormGroup>
            </GridItem>
          </Grid>

          <ListInline align="center" size="small" class="mrgt+">
            <li>
              <Btn variant="outline" @click="isOpen = false">
                {{ $t('common.cancel') }}
              </Btn>
            </li>
            <li>
              <Btn data-cy="save-button" type="submit" variant="primary">
                <Loader v-if="loading" size="small" negative />
                <template v-else>
                  {{ $t(`common.${contact.id ? 'edit' : 'add'}`) }}
                </template>
              </Btn>
            </li>
          </ListInline>
        </Form>
      </ValidationObserver>
    </main>
  </CDialog>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

import eventBus from '@/eventBus';
import { addExternalUser, updateExternalUser } from '@/services/external-users';

import Loader from '@/components/ui/Loader';
import Form from '@/components/forms/Form.vue';
import FormGroup from '@/components/forms/FormGroup.vue';

export default {
  components: {
    ValidationObserver,
    Loader,
    Form,
    FormGroup,
  },

  data() {
    return {
      isOpen: false,
      loading: false,
      contact: {
        id: null,
        first_name: null,
        last_name: null,
        username: null,
        company: null,
      },
    };
  },

  watch: {
    isOpen() {
      if (!this.isOpen) {
        this.contact.id = null;
        this.contact.first_name = null;
        this.contact.last_name = null;
        this.contact.username = null;
        this.contact.company = null;
      }
    },
  },

  mounted() {
    eventBus.$on('toggleContactAddOrUpdateDialog', this.handleToggle);
  },

  beforeDestroy() {
    eventBus.$off('toggleContactAddOrUpdateDialog', this.handleToggle);
  },

  methods: {
    handleToggle(contact) {
      if (contact) {
        this.contact = Object.assign({}, contact);
      }

      this.isOpen = !this.isOpen;
    },

    submit() {
      this.loading = true;

      this.addOrUpdateUser()
        .then(() => {
          this.isOpen = false;
          this.$emit('update');
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: this.$t('contacts.errors.failed'),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addOrUpdateUser() {
      return this.contact.id
        ? updateExternalUser(this.contact)
        : addExternalUser(this.contact);
    },
  },
};
</script>
